import React, { CSSProperties, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import './css/Computation.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faX } from '@fortawesome/free-solid-svg-icons';
import Navbar from './Navbar';
import Sidebar from './Sidebar';
import labg from "./images/iconsb/labb.png"
import HashLoader from "react-spinners/HashLoader";
import dogo from './images/agroCHEM.gif';
import labService from './labService';
import useLabSocket from './useLabSocket';

const FINISHED_STATUSES = ['Done', 'Failed', 'Deleted'];
const NOT_FOUND = 'This analysis could not be found. It may have been deleted.';


const Computation = ({ isCollapsed, toggleSidebar }) => {
    const navigate = useNavigate();
    const { pk } = useParams(); // Get the `pk` from the URL parameters
    const [notFound, setNotFound] = useState(false);

    const goToLab = () => {
        navigate('/laboratory');
    };

    const checkComputationStatus = async () => {
        try {
            const response = await labService.checkComputationStatus(pk);
            if (response.data.redirect_url) {
                // If computation is done, redirect to result page
                navigate(response.data.redirect_url);
            }
        } catch (error) {
            // Gone for good, so stop waiting. Anything else, such as a network failure, may pass:
            // the spinner stays and the next resync asks again.
            if (error.response && error.response.status === 404) {
                setNotFound(true);
                return;
            }
            console.error("Error fetching computation status:", error);
        }
    };

    useLabSocket({
        onResync: checkComputationStatus,
        onEvent: (message) => {
            if (String(message.analysis_id) === pk && FINISHED_STATUSES.includes(message.status)) {
                navigate('/laboratory/');
            }
        },
    });

    return (
        <div className='lab-container'>
            <Navbar />
            <div className='lab-side-content'>
                <Sidebar active_n={1} isCollapsed={isCollapsed} toggleSidebar={toggleSidebar} />
                <div className='new-pred-container'>
                    <div className='np-tabs'>
                        <div className='x'>
                            <button onClick={goToLab} className='x-but'>
                                <FontAwesomeIcon className='icon-x' icon={faX} />
                            </button>
                        </div>
                        <div className='np-steps comp-tab-1'>
                            <p className='p-step'>STEP 1</p>
                            <p>Select Model</p>
                        </div>
                        <div className='np-steps comp-tab-2'>
                            <p className='p-step'>STEP 2</p>
                            <p>Define Compound</p>
                        </div>
                        <div className='np-steps comp-tab-3'>
                            <p className='p-step'>STEP 3</p>
                            <p>Summary</p>
                        </div>
                        <div className='np-steps comp-tab-4'>
                            <p className='p-step'>STEP 4</p>
                            <p>Results</p>
                        </div>
                    </div>
                    <div className='np-content'>
                        <div className='loading-comp'>
                            {notFound ? (
                                <div className='load-div'>
                                    <p className='comp-error' role='alert'>{NOT_FOUND}</p>
                                    <button onClick={goToLab} className='lab-load'><img className="lab-load-icon" src={labg} alt="laboratory" />Laboratory</button>
                                </div>
                            ) : (
                                <>
                                    <HashLoader
                                    className='loader'
                                    size={120}
                                    color='#0b5578'
                                    />
                                    {/* <img className='loader dogo' src={dogo} alt="My Local GIF" /> */}
                                    <div className='load-div'>
                                        <p className='comp-run'>Computation running...</p>
                                        <p className='you-can-go'>You can go to the</p>
                                        <button onClick={goToLab} className='lab-load'><img className="lab-load-icon" src={labg} alt="laboratory" />Laboratory</button>
                                        <p>and wait for the results.</p>
                                    </div>
                                </>
                            )}
                        </div>
                    </div>
                </div>
            </div>
        </div>
      );
      
};

export default Computation;